var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgQuestionCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.8125C3.35918 0.8125 0.8125 3.35918 0.8125 6.5C0.8125 9.64082 3.35918 12.1875 6.5 12.1875C9.64082 12.1875 12.1875 9.64082 12.1875 6.5C12.1875 3.35918 9.64082 0.8125 6.5 0.8125ZM6.5 9.80078C6.21943 9.80078 5.99219 9.57353 5.99219 9.29297C5.99219 9.0124 6.21943 8.78516 6.5 8.78516C6.78057 8.78516 7.00781 9.0124 7.00781 9.29297C7.00781 9.57353 6.78057 9.80078 6.5 9.80078ZM7.29854 7.01416C7.18356 7.05856 7.08464 7.13657 7.01466 7.23803C6.94469 7.33948 6.90691 7.45967 6.90625 7.58291V7.87109C6.90625 7.92695 6.86055 7.97266 6.80469 7.97266H6.19531C6.13945 7.97266 6.09375 7.92695 6.09375 7.87109V7.59814C6.09375 7.30488 6.17881 7.01543 6.34639 6.77422C6.51016 6.53809 6.73867 6.35781 7.00781 6.25498C7.43945 6.08867 7.71875 5.72686 7.71875 5.33203C7.71875 4.77217 7.17158 4.31641 6.5 4.31641C5.82842 4.31641 5.28125 4.77217 5.28125 5.33203V5.42852C5.28125 5.48438 5.23555 5.53008 5.17969 5.53008H4.57031C4.51445 5.53008 4.46875 5.48438 4.46875 5.42852V5.33203C4.46875 4.83311 4.68711 4.36719 5.0832 4.02061C5.46406 3.68672 5.9668 3.50391 6.5 3.50391C7.0332 3.50391 7.53594 3.68799 7.9168 4.02061C8.31289 4.36719 8.53125 4.83311 8.53125 5.33203C8.53125 6.06582 8.04756 6.72598 7.29854 7.01416Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleFilled);
export default __webpack_public_path__ + "static/media/questionCircleFilled.41c1936968a207295570c92ae22929ca.svg";
export { ForwardRef as ReactComponent };